export interface ProjectWithLevel {
  [key: string]: any
  project_id: number
  project_name: string
  parent_id: number | null
  _level: number
}

export function flattenProjectsWithLevel<T extends { project_id: number; project_name: string; parent_id?: number | null }>(
  projects: T[]
): (T & { _level: number })[] {
  if (!projects || projects.length === 0) return []

  const idSet = new Set(projects.map(p => p.project_id))
  const childrenMap = new Map<number | null, T[]>()

  for (const project of projects) {
    // Orphans (parent not in list) are treated as roots
    const parentKey = project.parent_id != null && idSet.has(project.parent_id) ? project.parent_id : null
    if (!childrenMap.has(parentKey)) {
      childrenMap.set(parentKey, [])
    }
    childrenMap.get(parentKey)!.push(project)
  }

  // Sort each group alphabetically
  for (const children of childrenMap.values()) {
    children.sort((a, b) => a.project_name.localeCompare(b.project_name))
  }

  const result: (T & { _level: number })[] = []

  const traverse = (parentId: number | null, level: number) => {
    const children = childrenMap.get(parentId)
    if (!children) return
    for (const child of children) {
      result.push({ ...child, _level: level })
      traverse(child.project_id, level + 1)
    }
  }

  traverse(null, 0)
  return result
}
